import React, { Component } from 'react';
import LabeledInput from '../labeled-input';
import LabeledNumberRange from './labeledNumberRange';
import PropTypes from 'prop-types';

class LabeledNumberRangePicker extends Component {

    state = {
        showRange: true,
    }

    toggle = () => {

        this.setState( {
            showRange: !this.state.showRange,
        } );

    }

    handleNumberChange = ( props, name, date ) => {

        this.props.onChange( props, name, date );

    }

    render () {

        const {
            name, className, isRequired, from, to,
        } = this.props;
        const fromVal = ( !from ? '' : from );
        const toVal = ( !to ? '' : to );

        return (

            <div className="number-range-picker">
                <label>
                    {this.props.label}
                    <span className={`asterisk-icon ${isRequired ? 'mandatory' : ''}`}>
                        <i className="fa fa-asterisk" />
                    </span>
                </label>
                <div className={`serach-range ${!this.state.showRange ? 'show' : ''}`}>
                    <LabeledInput
                        className={className}
                        name={name}
                        isEditable={true}
                        label=" "
                        maxLength={15}
                        value={fromVal}
                        onChange={this.handleNumberChange.bind( this, this.props, 'serialNumber' )}
                    />

                </div>
                <div>
                    <div className={`serach-range ${this.state.showRange ? 'show' : ''}`}>
                        <LabeledNumberRange
                            className={className}
                            name={name}
                            from={fromVal}
                            to={toVal}
                            onChange={this.handleNumberChange.bind( this )}
                        />
                    </div>
                    <label className="serach-range-label" onClick={this.toggle}>
                        <i className={`arrow-icon fa ${!this.state.showRange ? 'fa-angle-down' : 'fa-angle-up'}`} />
                                        Search Range
                    </label>
                </div>

            </div>

        );

    }

}
LabeledNumberRangePicker.displayName = 'LabeledNumberRangePicker';
LabeledNumberRangePicker.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isRequired: PropTypes.bool.isRequired,
    from: PropTypes.number,
    to: PropTypes.number,
    className: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default LabeledNumberRangePicker;
